var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.template == 6)?_c('Cn',{attrs:{"data":_vm.contract}}):(_vm.template == 5)?_c('En',{attrs:{"data":_vm.contract}}):_c('Km',{attrs:{"data":_vm.contract}})}
var staticRenderFns = []

export { render, staticRenderFns }